module.exports = {
      id: "philp-flag-usage",
      viewBox: "0 0 16 12",
      url: __webpack_public_path__ + "svg-sprite-39dbc991ee8a2ec1b35aeef6495011e2.svg#philp-flag",
      toString: function () {
        return this.url;
      }
    }